import { Helmet } from 'react-helmet'
import { useParams } from 'react-router'

import MainHeader from '../../components/MainHeader/MainHeader.js'
import MainFooter from '../../components/MainFooter/MainFooter.js'
import CTAButton from '../../components/CTAButton/CTAButton.js'

import newsdatajson from '../../assets/newsdata.json'

import { lP, oP, sT } from '../../main.js'

import '../../main.css'
import './AktuellesDetail.css'
import './MAktuellesDetail.css'


export default function AktuellesDetail() {

    let { newsidurl } = useParams()
    let newsdata = newsdatajson.find((element) => element.newsid == newsidurl);

    let newstitle = newsdata.title != "" ? newsdata.title : "Fehler beim Laden des Titels"
    let newsdatum = newsdata.datum != "" ? newsdata.datum : "00.00.0000"
    let newsbody = newsdata.body != "" ? newsdata.body : "Fehler beim Laden des Newstextes."
    let newsausschnitt = newsdata.ausschnitt != "" ? newsdata.ausschnitt : "Aktuelle Neuigkeiten von it.liepert.gmbh."

    // const parser = new DOMParser();
    // const htmlnewsbody = parser.parseFromString(newsbody, 'text/xml');

    return (
        <div className='mainCon' id='mainCon'>
            <MainHeader selectedsite={"aktuelles"} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>{newstitle} | it.liepert.gmbh</title>
                <meta name="description" content={newsausschnitt} />
                <link rel="canonical" href={"https://www.liepert.de/aktuelles/" + newsidurl} />
                <meta property="og:type" content="article" />
                <meta property="og:site_name" content="it.liepert.gmbh" />
                <meta property="og:title" content={newstitle} />
                <meta property="og:description" content={newsausschnitt} />
                <meta property="og:url" content={"https://www.liepert.de/aktuelles/" + newsidurl} />
                <meta property="og:locale" content="de_DE" />
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content={newstitle} />
                <meta name="twitter:description" content={newsausschnitt} />
            </Helmet>

            <section className='sec_next' id='sec_next--aktuellesdetail'>
                <div className='sec_next_cont' id="sec_next--aktuellesdetail--cont">
                    <a className="pagebackbtn" href="/aktuelles">
                        <svg className="pagebackbtn_arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M19 12H5M12 19l-7-7 7-7" />
                        </svg>
                        <span>Zurück zur Übersicht</span>
                    </a>
                    <h2>{newstitle}</h2>
                    <b>{newsdatum}</b>
                    <div className='newsbodydiv' dangerouslySetInnerHTML={{ __html: newsbody }}></div>

                </div>
            </section>

            <MainFooter />
        </div>
    )
}